import styled, { css } from 'styled-components';

import { themeColor, themeColorWithOpacity, themeFont } from './getters';
import { media } from './media';
import { getUnderLine } from './mixins';

export const h1styles = css`
  font-family: ${themeFont('winnow')};
  color: ${themeColor('primary')};
  font-size: 32px;
  line-height: 42px;
  margin: 0;
  font-weight: normal;

  ${media.tablet`
    font-size: 80px;
    line-height: 94px;
  `};
`;

export const H1 = styled.h1`
  ${h1styles};
`;

export const H1smallDesktop = styled.h1`
  ${h1styles};

  ${media.tablet`
    font-size: 45px;
    line-height: 53px;
  `};
`;

export const H2 = styled.h2`
  font-family: ${themeFont('winnow')};
  color: ${themeColor('primary')};
  font-size: 32px;
  line-height: 42px;
  margin: 0;
  font-weight: normal;

  ${media.tablet`
    font-size: 50px;
    line-height: 59px;
  `};
`;

export const H3 = styled.h3`
  font-family: ${themeFont('winnow')};
  color: ${themeColor('primary')};
  font-size: 32px;
  line-height: 42px;
  margin: 0;
  font-weight: normal;
  ${media.tablet`
    font-size: 20px;
    line-height: 27px;
  `};
`;

export const nonResponsiveH3 = styled.h3`
  font-family: ${themeFont('winnow')};
  color: ${themeColor('primary')};
  font-size: 32px;
  line-height: 42px;
  margin: 0;
  font-weight: normal;
`;

export const link = css`
  position: relative;
  font-size: 14px;
  line-height: 140%;
  font-family: ${themeFont('winnow')};
  color: ${themeColor('primary')};
  cursor: pointer;
  text-transform: uppercase;

  text-decoration: underline;
  text-decoration-color: ${themeColorWithOpacity('primary', 0.2)};
  text-underline-position: under;
`;

export const inlineLink = css`
  ${link};
  font-size: 20px;
  line-height: 27px;
  text-transform: none;
  ${getUnderLine('primary')};
`;

export const experienceTileTitle = css`
  font-size: 18px;
  line-height: 24px;

  ${media.tablet`
    font-size: 20px;
    line-height: 27px;
  `}
`;

export const primaryText = css`
  font-family: ${themeFont('primary')};
  color: ${themeColor('primary')};
  font-weight: normal;
  margin: 0;
`;

export const winnowText = css`
  font-family: ${themeFont('winnow')};
  color: ${themeColor('primary')};
  font-weight: normal;
  margin: 0;
`;

export const winnowHeading = css`
  ${winnowText};
  font-size: 20px;
  line-height: 27px;
`;

export const spacedHeading = css`
  ${primaryText};
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  ${media.tablet`
    font-size: 18px;
    line-height: 23px;
    letter-spacing: 0.05em;
  `};
`;

export const nonResponsiveSpacedHeading = css`
  ${primaryText};
  font-size: 18px;
  line-height: 23px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

export const smallSpacedHeading = css`
  ${primaryText};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  ${media.tablet`
    font-size: 14px;
    line-height: 18px;
  `};
`;

export const nonResponsiveSmallSpacedHeading = css`
  ${primaryText};
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;

export const paragraph = css`
  ${primaryText};
  font-size: 16px;
  line-height: 21px;

  ${media.tablet`
    font-size: 18px;
    line-height: 24px;
  `};
`;

export const nonResponsiveParagraph = css`
  ${primaryText};
  font-size: 18px;
  line-height: 24px;
`;

export const smallParagraph = css`
  ${primaryText};
  font-size: 16px;
  line-height: 21px;
`;

export const modalHeading = css`
  ${winnowText};
  font-size: 32px;
  line-height: 42px;
  margin: 0;
`;

export const modalLink = css`
  ${smallParagraph};
  position: relative;
  cursor: pointer;
  ${getUnderLine('white')};
`;

export const bigQuote = css`
  font-family: ${themeFont('secondary')};
  color: ${themeColor('primary')};
  font-size: 24px;
  line-height: 34px;

  ${media.tablet`
    font-size: 48px;
    line-height: 71px;
  `};
`;

export const newsletter = css`
  font-family: ${themeFont('secondary')};
  color: ${themeColor('primary')};
  font-size: 24px;
  line-height: 34px;

  ${media.tablet`
    font-size: 32px;
    line-height: 47px;
  `};
`;
